import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IKanbanTodoItem } from "../models/Vehicle";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useVehicleWorkflow(vehicleId: string | undefined) {
  const { get } = useApiHelper(apiConfig("VehicleWorkflow"));

  return useQuery(
    ["vehicles", vehicleId, "workflow"],
    () => get<DefaultResponseWithData<IKanbanTodoItem[]>>(`/vehicle/${vehicleId}/workflow`),
    { enabled: !!vehicleId, staleTime: 1000 * 60 * 2 }
  );
}
